import { render, staticRenderFns } from "./BuyingInfoForm.vue?vue&type=template&id=763c9ffe&scoped=true&"
import script from "./BuyingInfoForm.vue?vue&type=script&lang=js&"
export * from "./BuyingInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c9ffe",
  null
  
)

export default component.exports